import React, { useState } from "react";
import { Drawer, Button } from "antd";
import Swal from "sweetalert2";
import axios from "axios";
import QRCodeBasic from "react-qr-code";
import { QRCode as QRCodeLogo } from "react-qrcode-logo";

// 🔧 Formatter modular untuk angka Pi
const formatPi = (value) => {
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 7,
    maximumFractionDigits: 7,
  });
};

export default function TransactionDrawer({
  transaction,
  visible,
  onClose,
  onStatusUpdated,
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  if (!transaction) return null;

  const handleMarkAsReceived = async () => {
    if (!transaction?.id) return;

    setIsUpdating(true);
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      await axios.put(
        `/api/transactions/${transaction.id}`,
        { status_delivery: "delivered" },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Barang diterima",
        text: "Status pengiriman telah diperbarui.",
      });

      onClose();
      onStatusUpdated();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Gagal update status",
        text: err.response?.data?.message || "Silakan coba lagi.",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Drawer
      title="🧾 Struk Transaksi"
      open={visible}
      onClose={onClose}
      placement="bottom"
      height="90vh"
      className="rounded-t-[20px]"
    >
      <div className="space-y-6 pb-24 font-mono text-sm">
        {/* QR Code */}
        <div className="flex justify-center">
          <QRCodeLogo
            value={`https://blockexplorer.minepi.com/mainnet/tx/${transaction?.trx_id}`}
            size={200}
            logoImage="/qrcodelogo.png"
            logoWidth={40}
            logoHeight={40}
            logoOpacity={1}
            removeQrCodeBehindLogo={true}
            qrStyle="dots"
            bgColor="#FFFFFF"
            fgColor="#2B2B2B"
          />
        </div>

        {/* Info Transaksi */}
        <div className="border-b pb-4">
          <p>🆔 ID: {transaction.identifier}</p>
          <p>
            📅 Tanggal:{" "}
            {new Date(transaction.created_at).toLocaleDateString("id-ID")}
          </p>
          <p>📦 Status: {transaction.status}</p>
          {transaction.awb && <p>🚚 Resi: {transaction.awb}</p>}
        </div>

        {/* Produk */}
        <div className="border-b pb-4">
          <p className="font-bold mb-2">🛒 Produk</p>
          {Array.isArray(transaction.items_product) &&
            transaction.items_product.map((item, i) => (
              <div key={i} className="flex justify-between">
                <span>
                  {item.nama} ({item.qty}x)
                </span>
                <span>{formatPi(item.subtotal)} π</span>
              </div>
            ))}
          <div className="mt-2 text-right font-bold">
            Total:{" "}
            <span title={`Nilai asli: ${transaction.amount}`}>
              {formatPi(transaction.amount)} π
            </span>
          </div>
        </div>

        {/* Alamat */}
        <div className="border-b pb-4">
          <p className="font-bold mb-2">📍 Alamat Pengiriman</p>
          <p>{transaction.address_user?.nama}</p>
          <p>{transaction.address_user?.telepon}</p>
          <p>
            {transaction.address_user?.alamat},{" "}
            {transaction.address_user?.kelurahan_id},{" "}
            {transaction.address_user?.kecamatan_id},{" "}
            {transaction.address_user?.kabupaten_id},{" "}
            {transaction.address_user?.provinsi_id}
            {transaction.address_user?.kodepos &&
              ` - ${transaction.address_user.kodepos}`}
          </p>
        </div>

        {/* Pembayaran */}
        <div className="border-b pb-4">
          <p className="font-bold mb-2">💰 Pembayaran</p>
          <p>Metode: {transaction.network}</p>
          <p>Wallet: {transaction.to_address}</p>
        </div>

        {/* Tombol Terima Barang */}
        {transaction?.awb &&
          transaction?.status_delivery === "on-delivery" && (
            <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t">
              <Button
                type="primary"
                block
                loading={isUpdating}
                onClick={handleMarkAsReceived}
                className="bg-gray-100 hover:bg-gray-700"
              >
                Tandai Sudah Diterima
              </Button>
            </div>
          )}
      </div>
    </Drawer>
  );
}
